var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.formData.project_type == 2 && _vm.formData.type.includes("1")) ||
    (_vm.formData.project_meeting &&
      _vm.formData.project_meeting.process_result === "1" &&
      _vm.formData.type.includes("1"))
    ? _c(
        "div",
        {
          staticClass: "sub-form-container",
          class: {
            "sub-form-disabled":
              _vm.isTaskFormDisabled("1") || _vm.isViewTaskDisabled("1"),
            "sub-form-editing": _vm.isEditingTask("1"),
          },
        },
        [
          _c("div", { staticClass: "sub-form-title" }, [
            _vm._v("商城装修需求信息"),
          ]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "使用场景",
                        prop: "items.mall_decoration.scene",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.formData.items.mall_decoration.scene,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData.items.mall_decoration,
                                "scene",
                                $$v
                              )
                            },
                            expression: "formData.items.mall_decoration.scene",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("下单使用"),
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("演示使用"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "装修交付时间",
                        prop: "items.mall_decoration.delivery_time",
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          readonly: _vm.isViewTaskDisabled("1"),
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          placeholder: "请选择",
                        },
                        model: {
                          value:
                            _vm.formData.items.mall_decoration.delivery_time,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData.items.mall_decoration,
                              "delivery_time",
                              $$v
                            )
                          },
                          expression:
                            "formData.items.mall_decoration.delivery_time",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "预算金额",
                        prop: "items.mall_decoration.budget",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          readonly: _vm.isViewTaskDisabled("1"),
                          placeholder: "请输入",
                        },
                        on: { input: _vm.handleBudgetInput },
                        model: {
                          value: _vm.formData.items.mall_decoration.budget,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData.items.mall_decoration,
                              "budget",
                              $$v
                            )
                          },
                          expression: "formData.items.mall_decoration.budget",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "商城名称（首页名称）",
                        prop: "items.mall_decoration.mall_name",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          readonly: _vm.isViewTaskDisabled("1"),
                          placeholder: "名称长度需在10个字符以内",
                          maxlength: 10,
                        },
                        model: {
                          value: _vm.formData.items.mall_decoration.mall_name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData.items.mall_decoration,
                              "mall_name",
                              $$v
                            )
                          },
                          expression:
                            "formData.items.mall_decoration.mall_name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "客户Banner",
                        prop: "items.mall_decoration.banner",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.formData.items.mall_decoration.banner,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData.items.mall_decoration,
                                "banner",
                                $$v
                              )
                            },
                            expression: "formData.items.mall_decoration.banner",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("更换"),
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("不更换"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "装修功能板块",
                        prop: "items.mall_decoration.modules",
                      },
                    },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.formData.items.mall_decoration.modules,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData.items.mall_decoration,
                                "modules",
                                $$v
                              )
                            },
                            expression:
                              "formData.items.mall_decoration.modules",
                          },
                        },
                        [
                          _c("el-checkbox", { attrs: { label: "1" } }, [
                            _vm._v("电影"),
                          ]),
                          _c("el-checkbox", { attrs: { label: "2" } }, [
                            _vm._v("生日"),
                          ]),
                          _c("el-checkbox", { attrs: { label: "3" } }, [
                            _vm._v("礼包"),
                          ]),
                          _c("el-checkbox", { attrs: { label: "4" } }, [
                            _vm._v("商城"),
                          ]),
                          _c("el-checkbox", { attrs: { label: "5" } }, [
                            _vm._v("其他"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.formData.items.mall_decoration.modules.includes("3")
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "礼包方案ID",
                            prop: "items.mall_decoration.package_id",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              readonly: _vm.isViewTaskDisabled("1"),
                              placeholder: "请输入",
                              maxlength: 50,
                            },
                            model: {
                              value:
                                _vm.formData.items.mall_decoration.package_id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData.items.mall_decoration,
                                  "package_id",
                                  $$v
                                )
                              },
                              expression:
                                "formData.items.mall_decoration.package_id",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "装修描述",
                        prop: "items.mall_decoration.remark",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          readonly:
                            _vm.isTaskFormDisabled("1") ||
                            _vm.isViewTaskDisabled("1"),
                          rows: 4,
                          placeholder: "请输入装修描述",
                          maxlength: 500,
                        },
                        model: {
                          value: _vm.formData.items.mall_decoration.remark,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData.items.mall_decoration,
                              "remark",
                              $$v
                            )
                          },
                          expression: "formData.items.mall_decoration.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.type != "add"
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "装修负责人",
                            prop: "items.mall_decoration.person_charge_id",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: "请选择装修负责人",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handlePersonChargeChange(
                                    _vm.formData.items.mall_decoration,
                                    _vm.decorationPersonList
                                  )
                                },
                              },
                              model: {
                                value:
                                  _vm.formData.items.mall_decoration
                                    .person_charge_id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.items.mall_decoration,
                                    "person_charge_id",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.items.mall_decoration.person_charge_id",
                              },
                            },
                            _vm._l(_vm.decorationPersonList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showProjectInfoEditButton("1")
            ? _c("section-edit-actions", {
                attrs: {
                  editing: _vm.isEditingTask("1"),
                  loading: _vm.editSaving,
                },
                on: {
                  start: function ($event) {
                    return _vm.startProjectInfoEdit("1")
                  },
                  confirm: _vm.confirmProjectInfoEdit,
                  cancel: _vm.cancelProjectInfoEdit,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }